
export default (window as any).require;